import { Category1LayoutDataProps } from './category1LayoutData';
import { FieldType } from 'enums/FieldTypeEnums';
import { CategoryOptions } from 'shared/components/CreateProductModal/ProductModalForm';
import { ReactComponent as MapSearch } from 'assets/icons/map-search.svg';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import { ReactComponent as DeleteButton } from 'assets/icons/close_enclosed.svg';
import styles from './category1.module.scss';
import { allowOnlyPercentages } from 'shared/utils/convertFormData';
import { categoryTypeFieldMap } from '../Category4&9/Category4Layout/category4LayoutData';
import { INGREDIENTS } from 'constants/Scope3Constants/category1.constants';
import { Category1Types } from 'enums/category1Enums';
import React from 'react';

export const getOriginsData = (props: Category1LayoutDataProps) => {
  const { LABELS } = INGREDIENTS;
  const {
    ORIGIN,
    PACKAGING_ORIGIN,
    OTHER_ORIGIN,
    BEST_FIT_REGION,
    UNIT,
    ORIGIN_SHARE,
  } = LABELS;
  const { OTHERS, PACKAGING_MATERIALS } = Category1Types;

  const {
    type,
    index,
    bestFitRegionOptions,
    removeOrigin,
    originIndex,
    setIsAddRegion,
    originsLength,
    loading,
    setValue,
  } = props;

  const removeOriginHandler = () => {
    if (originsLength === 2) {
      setValue?.(`${typeValue}.${index}.origins.0.share`, null);
    }
    removeOrigin?.(originIndex);
  };

  const handleOpenRequestRegionModal = () => setIsAddRegion?.(true);

  const typeValue = categoryTypeFieldMap[type];
  const originFieldLabel =
    type === OTHERS
      ? OTHER_ORIGIN
      : type === PACKAGING_MATERIALS
      ? PACKAGING_ORIGIN
      : ORIGIN;

  return {
    data: [
      {
        type: FieldType.ELEMENT,
        span: 6,
      },
      {
        type: FieldType.LOCATION_MODAL,
        fieldProps: {
          name: `${typeValue}.${index}.origins.${originIndex}.addressLabel`,
          label: originFieldLabel,
          placeholderstring: originFieldLabel,
          type,
          index,
          selectedOriginIndex: originIndex,
          suffix: <MapSearch />,
        },
        span: 5,
      },
      {
        type: FieldType.SELECT,
        fieldProps: {
          name: `${typeValue}.${index}.origins.${originIndex}.activityMappingRegionSpecId`,
          label: BEST_FIT_REGION,
          placeholderstring: BEST_FIT_REGION,
          showSearch: true,
          filterOption: (inputValue: string, option: CategoryOptions) =>
            option?.label?.toLowerCase().includes(inputValue.toLowerCase()),
          options: bestFitRegionOptions,
          loading: !!loading,
          dropdownRender: (menu: CategoryOptions) => (
            <>
              <div
                className={styles.dropdownCreateButton}
                onClick={handleOpenRequestRegionModal}>
                <Add /> {BEST_FIT_REGION}
              </div>
              {menu}
            </>
          ),
        },
        span: 5,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: `${typeValue}.${index}.origins.${originIndex}.share`,
          label: ORIGIN_SHARE,
          placeholderstring: ORIGIN_SHARE,
          onKeyDown: allowOnlyPercentages,
          isNullable: true,
        },
        span: 2,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: `${typeValue}.${index}.origins.${originIndex}.unit`,
          label: UNIT,
          placeholderstring: UNIT,
          value: '%',
          disabled: true,
        },
        span: 3,
      },
      {
        type: FieldType.ELEMENT,
        additionalElement: (
          <div className={styles.deleteContainer} onClick={removeOriginHandler}>
            <DeleteButton />
          </div>
        ),
      },
    ],
  };
};
